import { IDayPartBoundary, IValidDayPart } from 'state/day-part/hooks/use-active-day-parts';

export enum DAY_PART_SELECTIONS {
  DAYTIME_KEY = 'Main Menu',
  BREAKFAST_KEY = 'Breakfast',
  ALL_KEY = 'all',
  BURGERS_FOR_BREAKFAST = 'Burgers for Breakfast',
}

export interface IGetDayPart {
  currentDayPart: DAY_PART_SELECTIONS | null;
  dayParts: IValidDayPart[];
}

export interface IUseDayPart {
  breakfastInterval: IDayPartBoundary | undefined;
  mainMenuInterval: IDayPartBoundary | undefined;
  setDayPart: (newDayPart: DAY_PART_SELECTIONS) => void;
  getDayPart: () => IGetDayPart;
}
